export default "__VITE_ASSET__DBm3Of3Z__"